<template>
  <div>
    <panel-header />
    <student-loader @initialized="initialized = true" />
    <router-view v-if="initialized" />
  </div>
</template>

<script>
import StudentLoader from 'components/student-loader';
import PanelHeader from 'pages/panel/components/panel-header';
import { signInAnonymously } from 'firebase/auth';
import { getToken } from 'firebase/messaging';
import AppConfig from 'utils/app-config';
import NotificationTokenService from 'services/NotificationTokenService';
import { mapState } from 'vuex';

export default {
  components: {
    PanelHeader,
    StudentLoader,
  },
  computed: {
    ...mapState(['student']),
  },
  methods: {
    startFirebase() {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          signInAnonymously(this.$firebaseAuth).then(() => {
            this.generateFirebaseToken();
          }).catch(() => {});
        }
      });
    },
    generateFirebaseToken() {
      const vapidKey = AppConfig.get('firebaseVapidKey');

      getToken(this.$messaging, { vapidKey })
        .then((currentToken) => {
          this.handleFirebaseToken(currentToken);
        }).catch((err) => {
          // eslint-disable-next-line
          console.error('An error occurred while retrieving token. ', err);
        });
    },
    handleFirebaseToken(currentToken) {
      if (currentToken) {
        this.saveFirebaseToken(currentToken);
      } else {
        console.warn('No registration token available. Request permission to generate one.');
      }
    },
    saveFirebaseToken(currentToken) {
      const foundToken = this.filterConfirmationToken(currentToken);

      if (!foundToken || !foundToken.length) {
        NotificationTokenService.create(currentToken);
      }
    },
    filterConfirmationToken(targetToken) {
      const { notification_tokens: notificationTokens } = this.student;

      return notificationTokens.filter((item) => item.token === targetToken);
    },
  },
  created() {
    setTimeout(() => {
      this.startFirebase();
    }, 3000);
  },
  data() {
    return {
      initialized: false,
    };
  },
};
</script>
